export default "__VITE_ASSET__CdJvOnic__"